import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';

const SchoolSchedule = () => {
  const routes = all_routes;
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [viewMode, setViewMode] = useState('day');

  // Mock data
  const mockSchedule = [
    {
      id: 1,
      time: '09:00 - 09:45',
      class: 'Grade 10A',
      subject: 'Mathematics',
      teacher: 'Ms. Johnson',
      room: 'Room 201',
      status: 'Ongoing'
    },
    {
      id: 2,
      time: '10:00 - 10:45',
      class: 'Grade 11B',
      subject: 'Physics',
      teacher: 'Dr. Smith',
      room: 'Lab 1',
      status: 'Upcoming'
    },
    {
      id: 3,
      time: '11:00 - 11:45',
      class: 'Grade 9C',
      subject: 'English',
      teacher: 'Mr. Davis',
      room: 'Room 105',
      status: 'Upcoming'
    },
    {
      id: 4,
      time: '14:00 - 14:45',
      class: 'Grade 12A',
      subject: 'Chemistry',
      teacher: 'Dr. Wilson',
      room: 'Lab 2',
      status: 'Scheduled'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Ongoing': return 'badge-soft-warning';
      case 'Upcoming': return 'badge-soft-info';
      case 'Completed': return 'badge-soft-success';
      case 'Scheduled': return 'badge-soft-primary';
      case 'Cancelled': return 'badge-soft-danger';
      default: return 'badge-soft-secondary';
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Admin Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">School Schedule</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Schedule Controls */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">School Schedule Management</h4>
                  <div className="d-flex gap-2">
                    <button className="btn btn-primary btn-sm">
                      <i className="ti ti-plus me-1"></i>Add Class
                    </button>
                    <button className="btn btn-outline-primary btn-sm">
                      <i className="ti ti-download me-1"></i>Export
                    </button>
                  </div>
                </div>

                {/* Filters & View Controls */}
                <div className="card-body border-bottom">
                  <div className="row g-3 align-items-end">
                    <div className="col-md-3">
                      <label className="form-label">Select Date</label>
                      <input 
                        type="date" 
                        className="form-control"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">View Mode</label>
                      <select 
                        className="form-select"
                        value={viewMode}
                        onChange={(e) => setViewMode(e.target.value)}
                      >
                        <option value="day">Day View</option>
                        <option value="week">Week View</option>
                        <option value="month">Month View</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Filter by Class</label>
                      <select className="form-select">
                        <option>All Classes</option>
                        <option>Grade 9</option>
                        <option>Grade 10</option>
                        <option>Grade 11</option>
                        <option>Grade 12</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <button className="btn btn-outline-secondary w-100">
                        <i className="ti ti-refresh me-1"></i>Refresh
                      </button>
                    </div>
                  </div>
                </div>

                {/* TODO */}
                <div className="card-body border-bottom">
                  <div className="alert alert-info">
                    <h6><i className="ti ti-info-circle me-2"></i>TODO: Connect to schedule API</h6>
                    <ul className="mb-0">
                      <li>Fetch class schedules from database</li>
                      <li>Create/Edit/Delete class sessions</li>
                      <li>Handle conflicts and room booking</li>
                      <li>Generate timetable reports</li>
                    </ul>
                  </div>
                </div>

                {/* Schedule Table */}
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Time</th>
                          <th>Class</th>
                          <th>Subject</th>
                          <th>Teacher</th>
                          <th>Room</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockSchedule.map((item) => (
                          <tr key={item.id}>
                            <td><strong>{item.time}</strong></td>
                            <td>{item.class}</td>
                            <td>{item.subject}</td>
                            <td>{item.teacher}</td>
                            <td>{item.room}</td>
                            <td>
                              <span className={`badge ${getStatusColor(item.status)}`}>
                                {item.status}
                              </span>
                            </td>
                            <td>
                              <div className="dropdown">
                                <button className="btn btn-white btn-sm dropdown-toggle" data-bs-toggle="dropdown">
                                  Actions
                                </button>
                                <ul className="dropdown-menu">
                                  <li><button className="dropdown-item"><i className="ti ti-eye me-2"></i>View Details</button></li>
                                  <li><button className="dropdown-item"><i className="ti ti-edit me-2"></i>Edit</button></li>
                                  <li><button className="dropdown-item text-danger"><i className="ti ti-x me-2"></i>Cancel</button></li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SchoolSchedule;
